<template>
    <div class="handler--basic-fields-list">
        <div
            class="handler--basic-fields-list__input position--relative"
            v-for="input in inputs"
            :key="input.id"
        >
            <dynamic-fields
                class="contact__dynamic"
                :obj="{
                    [input.label.name]: input.label.value,
                    [input.value.name]: input.value.value
                }"
                :isEdition="isEdition"
                :allowFilling="allowFilling"
                :translations="translations"
            />

            <button-with-icon
                v-if="inputs.length > 1"
                class="handler--basic-fields-list__button--delete position--absolute"
                :icon="{
                    component: () => import(
                        /* webpackChunkName: 'IconTrash' */ '@/components/bundles/layout/images/icons/IconTrash'
                    )
                }"
                :aria-label="$t('accessibility.delete')"
                :action="{
                    execute: true,
                    function: actions.delete(),
                    param: input.id
                }"
            />
        </div>
        <button-with-icon
            class="handler--basic-fields-list__button--add"
            :icon="{
                component: () => import( /* webpackChunkName: 'IconPlus' */ '@/components/bundles/layout/images/icons/IconPlus' )
            }"
            :aria-label="$t('accessibility.addProp', { prop: $t('accessibility.field') })"
            :action="{
                execute: true,
                function: actions.add()
            }"
        />
    </div>
</template>

<script>
import { reactive, toRefs, onMounted } from '@vue/composition-api';

export default {
    components: {
        DynamicFields: () => import( /* webpackChunkName: 'DynamicFields' */ '@/components/bundles/layout/dynamicFields/DynamicFields' ),
        ButtonWithIcon: () => import( /* webpackChunkName: 'ButtonWithIcon' */ '@/components/bundles/buttons/BaseButtonWithIcon' )
    },
    props: {
        groupName: {
            type: String,
            default: 'input'
        },
        isEdition: {
            type: Boolean,
            default: false
        },
        allowFilling: {
            type: Boolean,
            default: true
        },
        translations: {
            type: Array,
            default: () => ( [ 'fieldName', 'value' ] )
        }
    },
    setup ( props ) {
        const state = reactive({
            currentId: 1,
            inputs: [],
            actions: {
                add: () => addInput,
                delete: () => deleteInput
            }
        });

        onMounted( () => {
            addInput();
        });

        // Função que incrementa o currentId
        const incrementCurrentId = () => state.currentId++;

        // Função que adiciona uma nova input
        const addInput = () => {
            state.inputs.push({
                id: state.currentId,
                label: { name: `${props.groupName}-label-${state.currentId}`, value: '' },
                value: { name: `${props.groupName}-value-${state.currentId}`, value: '' }
            });

            // Após adicionar campo, incrementa o id atual
            incrementCurrentId();
        };

        // Função que remove uma input
        const deleteInput = inputId => {
            state.inputs = state.inputs.filter( input => input.id !== inputId );
        };

        return {
            ...toRefs( state )
        };
    }
};
</script>

<style lang="scss">
    .handler {
        &--basic-fields-list {
            &__input {
                width: calc( 100% - 60px);
            }
            &__button {
                &--delete {
                    @include transform-position ( 50%, -60px, false, false, translateY( -50% ) );
                }
            }
        }
    }
</style>